export default __webpack_public_path__ + "static/media/cellar.a20b2629.jpg";